import React, { Component } from 'react';
import $ from 'jquery';

//const stripe = useStripe();
//const elements = useElements();
export default class SubscribeData extends Component {
    static displayName = SubscribeData.name;

    constructor(props) {
        super(props);
        this.state = {changeMade:false,
           message: this.props.message, teamsPaidByOther: [], teamsPaidFor: [], teamsUnpaid: [], teamsAddPay: [], teamsRemovePay: [],
        }
      
    }
    


    getData = async () => {

        const resp = await fetch('api/billing/teamlistbilling', {
            method: 'GET',
            credentials: 'same-origin'
        });
        if (resp.status === 200) {
            try {
                const jdata = await resp.json();

                if (this._isMounted) {
                    //await this.setState({ teams: jdata.teams });


                    await this.setState({
                        teamsPaidByOther: jdata.otherpaidList.sort(this.sorter),
                        teamsPaidFor: jdata.accpaidList.sort(this.sorter),
                        teamsUnpaid: jdata.unpaidList.sort(this.sorter),
                        message: jdata.message
                    }, () => {
                        let teamsbool = this.state.teamsPaidByOther.length === 0 && this.state.teamsPaidFor.length === 0 && this.state.teamsUnpaid.length === 0;
                        if (teamsbool) {
                            this.setState({ message: "You aren't part of a team yet" });
                        }
                        this.props.showBusy(false);
                    });


                }

            } catch (e) {
                //console.log(resp.statusText);
                this.setState({ message: '500: Check console' })
            }
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else if (resp.status === 400) {
            this.setState({ message: 'There was a problem accessing your billing info: Contact Support' })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });
           
        }
      
    }

    confirm = () => {
        if (this.state.teamsAddPay.length > 0 || this.state.teamsRemovePay.length > 0) {
            this.setState({ message: "" });
            $('#confirmModal').modal();
        }
        else {
            this.setState({ message: "You must make a change first." });
        }
    }
    sorter = (a, b) => {
        if (a.name < b.name) return -1; if (a.name > b.name) return 1; return 0;    
    }

    async componentDidMount() {
        this._isMounted = true;
        this.props.showBusy(true);
        await (async () => {
            this.getData()
        })();
        this.props.showBusy(false);
    }
    //async componentDidUpdate(prevProps) {
    //    console.log(this.props);
    //    if (this.props.message !== prevProps.message) {
    //        console.log("In Didupdate");
    //        await this.setState({ inProcess: false ,message:this.props.message});
    //        await (async () => {
    //            this.getData()
    //        })();
    //    }
    //}
    addToPaid = async (e) => {

        let tempteamsAddPay = this.state.teamsAddPay;
        if (e.target.checked) {
            tempteamsAddPay.push(this.state.teamsUnpaid.filter(x => x.sort === e.target.id)[0]);
        }
        else {
            tempteamsAddPay = tempteamsAddPay.filter(x => x.sort !== e.target.id)
        }
        await this.setState({ teamsAddPay: tempteamsAddPay });
        if (this.state.teamsAddPay.length > 0 || this.state.teamsRemovePay.length > 0) {
             this.setState({  changeMade: true });
        }
        else this.setState({ changeMade: false });

    };
    removeFromPaid = async (e) => {

        let tempteamsRemovePay = this.state.teamsRemovePay;
        if (!e.target.checked) {
            tempteamsRemovePay.push(this.state.teamsPaidFor.filter(x => x.sort === e.target.id)[0]);
        }
        else {
            tempteamsRemovePay = tempteamsRemovePay.filter(x => x.sort !== e.target.id)
        }
       

        await this.setState({ teamsRemovePay: tempteamsRemovePay});
        if (this.state.teamsAddPay.length > 0 || this.state.teamsRemovePay.length > 0) {
            this.setState({ changeMade: true });
        }
        else this.setState({ changeMade: false });
    
    };

    submitting = async () => {            
        $('#confirmModal').modal('toggle');       
            await (async () => {
                this.props.submit(this.state.teamsAddPay, this.state.teamsRemovePay)
            })();           
        
    }
    retry = async (e, subId) => {
        e.preventDefault();
        await this.setState({ inProcess: true });
        await (async () => {
            this.props.retry(subId);
        })();

    }
    render() {
        const msg = !!this.state.message ?<div className="alert alert-danger col"> {this.state.message} </div> :"";
        const adjFee = 10 * (this.state.teamsPaidFor.length + this.state.teamsAddPay.length - this.state.teamsRemovePay.length);
        const show = this.state.changeMade ? "visible" : "invisible";

        return (
            <div>
                <div className="row">
                    <div className="col">
                        <h2>Teams </h2>
                        <div className="alert alert-primary">
                            <p >Check a team to start paying, or uncheck to stop then click confirm. </p>
                            <p >Teams paid by someone else will appear <span className="alert-light">gray</span>.</p>
                        </div>
                     
                        <div className="mt20">
                            {this.state.teamsPaidByOther.length > 0 ?
                                this.state.teamsPaidByOther.map(team => <TeamInfo key={team.sort} {...team} onSelection={this.removeFromPaid} isChecked={true} paidOther={true} />) :
                                <div></div>}
                            {this.state.teamsPaidFor.length > 0 ?
                                this.state.teamsPaidFor.map(team => <TeamInfo key={team.sort} {...team} onSelection={this.removeFromPaid} isChecked={true} retry={this.retry} />) :
                                /*   <div> You aren't paying for any teams.</div>*/
                                <div> </div>}
                            {this.state.teamsUnpaid.length > 0 ?
                                this.state.teamsUnpaid.map(team => <TeamInfo key={team.sort} {...team} onSelection={this.addToPaid} />) :
                                /* <div>There are no teams you can pay for.</div>*/
                                <div></div>}
                        </div>
                    </div>

                </div>

                <button type="button" className={"btn btn-primary  mt20 " + show} onClick={this.confirm}  >Confirm </button>
                {/*<button type="button" className="btn btn-danger  mt20" onClick={this.props.cancel} >Cancel </button>*/}
                <div className="row mt20"> {msg}</div>

                <div className="modal" tabIndex="-1" role="dialog" id="confirmModal">
                    <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Review Changes </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="mt20">
                                    {this.state.teamsRemovePay.length > 0 ?
                                        <div>
                                            Stop paying for these teams
                                            <ul className="list-group">
                                                {this.state.teamsRemovePay.map(team => <li key={team.sort} className="list-group-item">{team.name}  </li>)}
                                            </ul>

                                        </div> : ""}
                                    {this.state.teamsAddPay.length > 0 ?
                                        <div>
                                            Start paying for these teams
                                            <ul className="list-group">
                                                {this.state.teamsAddPay.map(team => <li key={team.sort} className="list-group-item">{team.name}  </li>)}
                                            </ul>

                                        </div> : ""}
                                </div>
                                <div> New Monthly Payment*: ${adjFee} </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={this.submitting} >Confirm Payment</button>
                                <button type="button" className="btn btn-light" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
class TeamInfo extends Component {


    render() {
        const premLabel = this.props.paidOther ? "(Premium)" : "";
        let splName = this.props.name.split(":");
      
        const warningCheck = this.props.name.split(":").length > 1;
        const warnBadge = warningCheck ? <a href="#" className="badge badge-danger ml-3 button" onClick={(e) => { this.props.retry(e,this.props.branding.paymentId); }  }>$ Retry </a>  : "";
    
        return (<div className="form-check">

            <input onChange={(e) => this.props.onSelection(e)} className="form-check-input" type="checkbox" disabled={this.props.paidOther} id={this.props.sort} value="" {...(this.props.isChecked ? { defaultChecked: "checked" } : {})} ></input>
            <label className="form-check-label" htmlFor={this.props.sort}>
                {splName[0]} {premLabel} 
            </label>
            {warnBadge}
        </div>);
    }
}

